export const fmtDate = (v: unknown) => (v ? String(v).slice(0, 10) : '—');
export const fmtWhen = (v: unknown) => {
  if (!v) return '—';
  const d = new Date(String(v));
  return Number.isNaN(d.getTime()) ? String(v).slice(0, 16) : d.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
};
export const money = (cents: number | null | undefined, cur = 'USD') =>
  cents == null ? '—' : new Intl.NumberFormat(undefined, { style: 'currency', currency: cur || 'USD', maximumFractionDigits: 0 }).format(cents / 100);
export const pct = (n: unknown, d: unknown) => (Number(d) ? `${Math.round((Number(n) / Number(d)) * 1000) / 10}%` : '—');
export const plural = (n: number, word: string) => `${n} ${word}${n === 1 ? '' : 's'}`;
export const today = () => new Date().toISOString().slice(0, 10);

/** Form values: '' → null, so PATCH clears a field instead of storing an empty string. */
export const clean = (values: Record<string, any>) => { const o: Record<string, any> = {}; for (const [k, v] of Object.entries(values)) o[k] = v === '' ? null : v; return o; };
export const num = (v: unknown) => (v === '' || v == null ? null : Number(v));
export const cents = (v: unknown) => (v === '' || v == null ? null : Math.round(Number(v) * 100));
